import React, { useState } from 'react';
import { Typography, Button, Drawer, message, Tooltip } from 'antd';
import { XMLValidator } from 'fast-xml-parser';
import PropTypes from 'prop-types';
import { slugRegex } from '../../util';
import SiteDataForm from './SiteDataForm';
import { updateLandingPage } from '../../api';
import closeIcon from '../../close.svg';

const SiteDataDrawer = ({
  details,
  closeDrawer,
  pageDetails,
  isDrawerVisible,
  onUpdate,
  type = 'add',
  pageHost,
}) => {
  const [loading, setLoading] = useState(false);
  const [drawerClosed, setDrawerClosed] = useState(false);
  const [updatedSiteData, setUpdatedSiteData] = useState(null);

  const handleCancel = () => {
    setDrawerClosed(!drawerClosed);
    closeDrawer();
  };

  const drawerMaskStyle = {
    backgroundColor: 'rgba(244, 244, 244, 0.8)',
  };

  const drawerHeaderStyle = {
    padding: '15px 20px',
  };

  const drawerBodyStyle = {
    padding: '45px 60px',
  };

  const handleUpdate = async () => {
    if (!updatedSiteData) {
      closeDrawer();
    }
    if (
      updatedSiteData?.title.length > 0 &&
      updatedSiteData?.description.length > 0 &&
      updatedSiteData?.customSlug.length > 0
    ) {
      if (!updatedSiteData?.customSlug.match(slugRegex)) {
        message.error("Custom slug doesn't match the pattern");
        return;
      }
      if (updatedSiteData?.customHeaderTags) {
        const XMLOptions = {
          allowBooleanAttributes: true,
          ignoreAttributes: false,
          alwaysCreateTextNode: true,
        };
        const validated = XMLValidator.validate(
          `<div>${updatedSiteData?.customHeaderTags}</div>`,
          XMLOptions
        );
        if (!validated) {
          message.error('Invalid tags');
          return;
        }
      }
      setLoading(true);
      const response = await updateLandingPage(
        pageDetails?._id,
        updatedSiteData
      );
      if (response?.code === 0) {
        const { title, description, customSlug, publishedLink } =
          response.result;
        onUpdate(pageDetails?._id, {
          title,
          description,
          customSlug,
          publishedLink,
        });
        closeDrawer();
        message.success('Successfully updated site data!');
      } else {
        message.error(response?.result || 'Something went wrong');
      }
    } else {
      message.error('Please fill all the fields');
    }
    setLoading(false);
  };

  return (
    <Drawer
      title={
        <div className="inviteAudienceFormHeader">
          <div className="invideAudienceCreatorDetails">
            <Typography.Text className="creator">
              {details?.name}
            </Typography.Text>
            <Typography.Title level={3} className="title" style={{ margin: 0 }}>
              {type === 'edit' ? 'Edit' : 'Add'} Site Data
            </Typography.Title>
          </div>
        </div>
      }
      footer={
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Tooltip
            title={pageDetails === null ? 'Please save the page first' : ''}
          >
            <span>
              <Button
                type="primary"
                className="siteBtn siteBtnPrimary"
                loading={loading}
                onClick={() => handleUpdate()}
                disabled={pageDetails === null}
              >
                Submit
              </Button>
            </span>
          </Tooltip>
        </div>
      }
      className="inviteAudienceDrawer"
      width={800}
      onClose={handleCancel}
      closeIcon={<img src={closeIcon} alt="close" />}
      open={isDrawerVisible}
      maskStyle={drawerMaskStyle}
      headerStyle={drawerHeaderStyle}
      bodyStyle={drawerBodyStyle}
      destroyOnClose
      style={{ zIndex: 1002 }}
    >
      <SiteDataForm
        pageDetails={pageDetails}
        handleChange={(data) => setUpdatedSiteData(data)}
        pageHost={pageHost}
      />
    </Drawer>
  );
};

SiteDataDrawer.propTypes = {
  details: PropTypes.shape({
    profilePic: PropTypes.string,
    name: PropTypes.string,
  }),
  closeDrawer: PropTypes.func,
  pageDetails: PropTypes.shape(Object),
  isDrawerVisible: PropTypes.bool,
  onUpdate: PropTypes.func,
  type: PropTypes.string,
  pageHost: PropTypes.string,
};

export default SiteDataDrawer;
